import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["theme", "size", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import "./index.css";
import styles from "./index.css.js";
var sizeStyles = {
  "s": styles.sizeS,
  "m": styles.sizeM,
  "l": styles.sizeL
};
export var Size = {
  "s": "s",
  "m": "m",
  "l": "l"
};
var LoadingIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      size = _ref.size,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props, {
    className: cn(styles.icon, styles[theme], sizeStyles[size], className),
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "rs-icon-rotate 1s linear infinite",
      transformOrigin: "center center"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 2c5.523 0 10 4.477 10 10h-2a8 8 0 00-8-8V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-2a8 8 0 11-8-8V2z"
  })));
});
LoadingIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["s", "m", "l"])
};
LoadingIcon.defaultProps = {
  size: "m"
};
export default LoadingIcon;
//# sourceMappingURL=loading.js.map